import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
	protected _sanitizer = inject(DomSanitizer);


	public transform(value: string, type: string): string | SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
		if (!value) {
			return value;
		}

		switch (type) {
			case 'html':
				return this._sanitizer.bypassSecurityTrustHtml(DOMPurify.sanitize(value));
			case 'style':
				return this._sanitizer.bypassSecurityTrustStyle(value);
			case 'script':
				return this._sanitizer.bypassSecurityTrustScript(value);
			case 'url':
				return this._sanitizer.bypassSecurityTrustUrl(value);
			case 'resourceUrl':
				return this._sanitizer.bypassSecurityTrustResourceUrl(value);
			default:
				throw new Error(`Unable to bypass security for invalid type: ${type}`);
		}
	}

}